/** Chaves de querystring da Agenda individual. A URL é a fonte da verdade dos filtros: um reload recupera o que estava filtrado. */
export const AGENDA_FILTRO_PARAMS = {
  connect: 'connect',
  zonaVermelha: 'zonaVermelha',
  regular: 'regular',
  preEscolar: 'preEscolar',
} as const;

export const AGENDA_FILTRO_LISTA_PARAMS = {
  professorIds: 'professorIds',
  materiaIds: 'materiaIds',
  estagios: 'estagios',
  alunoIds: 'alunoIds',
} as const;

export type AgendaFiltroChave = keyof typeof AGENDA_FILTRO_PARAMS;
export type AgendaFiltroListaChave = keyof typeof AGENDA_FILTRO_LISTA_PARAMS;

export interface AgendaFiltros {
  professorIds: string[];
  materiaIds: string[];
  estagios: string[];
  alunoIds: string[];
  connect: boolean;
  zonaVermelha: boolean;
  regular: boolean;
  preEscolar: boolean;
}

function lerLista(searchParams: URLSearchParams, paramKey: string): string[] {
  const valor = searchParams.get(paramKey);
  return valor ? valor.split(',').filter(Boolean) : [];
}

export function lerFiltrosDaUrl(searchParams: URLSearchParams): AgendaFiltros {
  return {
    professorIds: lerLista(searchParams, AGENDA_FILTRO_LISTA_PARAMS.professorIds),
    materiaIds: lerLista(searchParams, AGENDA_FILTRO_LISTA_PARAMS.materiaIds),
    estagios: lerLista(searchParams, AGENDA_FILTRO_LISTA_PARAMS.estagios),
    alunoIds: lerLista(searchParams, AGENDA_FILTRO_LISTA_PARAMS.alunoIds),
    connect: searchParams.get(AGENDA_FILTRO_PARAMS.connect) === 'true',
    zonaVermelha: searchParams.get(AGENDA_FILTRO_PARAMS.zonaVermelha) === 'true',
    regular: searchParams.get(AGENDA_FILTRO_PARAMS.regular) === 'true',
    preEscolar: searchParams.get(AGENDA_FILTRO_PARAMS.preEscolar) === 'true',
  };
}

export function comFiltroAtualizado(
  searchParams: URLSearchParams,
  chave: AgendaFiltroChave,
  valor: string | boolean,
): URLSearchParams {
  const proximo = new URLSearchParams(searchParams);
  const paramKey = AGENDA_FILTRO_PARAMS[chave];
  if (valor === '' || valor === false) {
    proximo.delete(paramKey);
  } else {
    proximo.set(paramKey, String(valor));
  }
  return proximo;
}

export function comFiltroListaAtualizado(
  searchParams: URLSearchParams,
  chave: AgendaFiltroListaChave,
  valores: string[],
): URLSearchParams {
  const proximo = new URLSearchParams(searchParams);
  const paramKey = AGENDA_FILTRO_LISTA_PARAMS[chave];
  if (valores.length === 0) {
    proximo.delete(paramKey);
  } else {
    proximo.set(paramKey, valores.join(','));
  }
  return proximo;
}
